import React, { useEffect, useRef } from 'react';
import Message, { SenderEnum } from './Message';
/**
 * @param messages: texts to show in the chat
 * @param recommendations: texts in case no messages are present
 * @returns
 */
export const ChatWindow = ({ messages, recommendations = [], isLoading = false, showMessageMetadata, style, }) => {
    const chatEndRef = useRef(null);
    const prevMessagesLength = useRef(0);
    // console.log(messages.length);
    // console.log(prevMessagesLength.current);
    useEffect(() => {
        if (messages.length > prevMessagesLength.current) {
            chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
        prevMessagesLength.current = messages.length;
    }, [messages]);
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '10px',
            marginBottom: '10px',
            backgroundColor: '#f4f4f4',
            height: '100%',
            width: '100%',
            overflowY: 'scroll',
            overflowX: 'hidden',
            ...style,
        } },
        messages.length < 1 ? (React.createElement("div", { style: { margin: 'auto', display: 'flex', flexWrap: 'wrap', gap: 30 } }, recommendations.map((rec, index) => (React.createElement("div", { key: index, className: "chat-recommendation clickable", onClick: rec.onClick, onKeyDown: () => { }, role: "button", tabIndex: 0 }, rec.text))))) : null,
        messages.map((msg, index) => (React.createElement(Message, { key: index, message: msg }))),
        isLoading && React.createElement(Message, { message: { text: 'Thinking...', sender: SenderEnum.bot } }),
        React.createElement("div", { ref: chatEndRef })));
};
export default ChatWindow;
